import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PlayerPage = () => {
  const { id } = useParams();

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-[100px] px-4 flex flex-col items-center">
        <div className="w-full max-w-4xl aspect-video">
          <iframe
            src={`https://embed.rusticoplay.com/${id}`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
            title="Player Video"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PlayerPage;
